import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_awesome_paginate = _resolveComponent("vue-awesome-paginate")!

  return (_openBlock(), _createBlock(_component_vue_awesome_paginate, {
    modelValue: _ctx.store.state.pagination.page,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.store.state.pagination.page) = $event)),
    "total-items": _ctx.store.state.pagination.totalCount ?? 0,
    "items-per-page": _ctx.store.state.pagination.perPage,
    "max-pages-shown": _ctx.maxPagesShown,
    "on-click": _ctx.clickHandler,
    "pagination-container-class": "default-pagination uk-pagination",
    "active-page-class": "uk-active",
    "back-button-class": "uk-pagination-previous",
    "next-button-class": "uk-pagination-next",
    "prev-button-content": _ctx.prevButtonContent ?? _ctx.$t('shared.pagination.prev'),
    "next-button-content": _ctx.nextButtonContent ?? _ctx.$t('shared.pagination.next')
  }, null, 8, ["modelValue", "total-items", "items-per-page", "max-pages-shown", "on-click", "prev-button-content", "next-button-content"]))
}